<template>
  <div class="card popin-synchro" v-if="objectPatrimoine">
    <div class=" card-content has-text-link">
      <b-icon class="icon is-left mgr-10px"
        icon="autorenew" type="is-primary" size="is-large">
      </b-icon>
      <h2 class="has-text-weight-bold mgt-20px mgb-20px">
        {{$t('catalogue.newProduct.popinSynchro.titre')}}
      </h2>
      <p class="has-text-default mgb-10px">
        {{$t('catalogue.newProduct.popinSynchro.texte1')}}
      </p>
      <p class="has-text-default mgb-20px">
        {{$t('catalogue.newProduct.popinSynchro.texte2')}}
      </p>
      <router-link-blank v-if="objectPatrimoine.materiel"
          :to="{ name: 'm.gabed.emplacement-faceEdition',
          params: {
                  id:objectPatrimoine.materiel.dispositif.emplacementId,
                  idMateriel: objectPatrimoine.materiel.id,
                  idFace: objectPatrimoine.id
                }
              }"
          :message="$t('catalogue.newProduct.popinSynchro.update')"
          classMessage="button is-primary"
        />
      <router-link-blank v-else
          :to="{ name: 'm.gabed.emplacement-materielEdition',
          params: {
                  id:objectPatrimoine.dispositif.emplacementId,
                  idMateriel: objectPatrimoine.id,
                }
              }"
          :message="$t('catalogue.newProduct.popinSynchro.update')"
          classMessage="button is-primary"
        />
    </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    objectPatrimoine: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  components: {
    routerLinkBlank,
  },
};
</script>

<style scoped>

</style>
